import { Pipe, PipeTransform } from '@angular/core';
import { Schema } from '@app/core/_models/schema';

@Pipe({
  name: 'propertyArrayHintText',
})
export class PropertyArrayHintTextPipe implements PipeTransform {
  public transform(properties: Schema, controlName: string): string {
    const field = properties.getField(controlName);

    if (field.minItems && field.maxItems) {
      return 'profile-form.array_property.hint.select_at_least_and_no_more_than';
    }

    if (field.minItems && !field.maxItems) {
      return 'profile-form.array_property.hint.select_at_least';
    }

    if (!field.minItems && field.maxItems) {
      return 'profile-form.array_property.hint.select_no_more_than';
    }

    return '';

  }
}
